import React, { useEffect, useState } from "react";

export function formatTime(seconds: number) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);
  return [h, m > 9 ? m : h ? "0" + m : m || "0", s > 9 ? s : "0" + s]
    .filter(Boolean)
    .join(":");
}

export function Duration({ start }: { start: number | undefined }) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    let intervalId: number | undefined = undefined;
    if (start) {
      intervalId = window.setInterval(() => {
        setValue(Date.now() - start);
      }, 500);
    }
    return () => window.clearInterval(intervalId);
  }, [start]);
  return value ? <small>{formatTime(value / 1000)}</small> : null;
}
